// removed by extract-text-webpack-plugin
module.exports = {"button":"_3FMsQ","enter":"_367Y3","enterActive":"_1Valv","leave":"g7FDl","leaveActive":"_3tJ58"};


//////////////////
// WEBPACK FOOTER
// ./app/components/floating-action-button/styles.scss
// module id = 1525
// module chunks = 0